import React from 'react';
import { useNavigate } from 'react-router-dom';

/* ─────────────────────────────────────────────────────────────────────────────
   DeleteAccountInfoPage — public, no-login-required landing for Google Play /
   App Store's account-deletion requirement (safer-sdn.com/delete-account).
   The actual deletion still happens on PassengerProfilePage (requires login +
   PIN confirmation, by design — see backend/authController.js's
   deleteAccount) — this page exists so the URL itself loads without an
   account or the app installed, and explains the steps.
───────────────────────────────────────────────────────────────────────────── */
const DeleteAccountInfoPage = () => {
  const navigate = useNavigate();
  const isLoggedIn = !!JSON.parse(localStorage.getItem('passenger_user') || 'null')?.id;

  return (
    <div dir="rtl" className="min-h-screen bg-[#F5F9FF] flex items-center justify-center p-6">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-[0_4px_24px_rgba(7,30,82,.10)] border border-[#E5E7EB] p-8 text-center">
        <img src="/logo.png" alt="سافر" className="w-16 h-16 rounded-2xl object-cover mx-auto mb-4" />
        <h1 className="text-xl font-black text-gray-900 mb-2">حذف الحساب</h1>
        <p className="text-sm text-gray-700 leading-relaxed mb-6">
          يمكنك حذف حسابك في سافر وبياناتك الشخصية المرتبطة به في أي وقت.
          عند حذف الحساب، يُعطَّل فوراً ولا يمكن استخدامه لتسجيل الدخول مرة أخرى.
        </p>

        <div className="bg-gray-50 rounded-xl p-4 text-right mb-6 space-y-2">
          <p className="text-xs font-bold text-gray-700">خطوات الحذف:</p>
          <ol className="text-sm text-gray-700 leading-relaxed list-decimal list-inside space-y-1">
            <li>سجّل الدخول برقم هاتفك ورمز PIN (من التطبيق أو من المتصفح).</li>
            <li>افتح صفحة «حسابي».</li>
            <li>اختر «حذف الحساب» وأكّد العملية برمز PIN.</li>
          </ol>
        </div>

        <button
          onClick={() => navigate(isLoggedIn ? '/profile' : '/login?from=/profile')}
          className="w-full bg-[#1E40AF] hover:bg-[#1D4ED8] text-white font-bold py-3 rounded-xl transition-colors text-sm"
        >
          {isLoggedIn ? 'الذهاب إلى حسابي' : 'تسجيل الدخول لحذف الحساب'}
        </button>
      </div>
    </div>
  );
};

export default DeleteAccountInfoPage;
